import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { contentData } from '../data/contentData';

const BenefitsGrid = () => {
  const { language } = useLanguage();
  const content = contentData[language].benefits;

  return (
    <section className="benefits-section" style={{ 
      padding: '20px 0 80px', 
      background: '#000000',
      fontFamily: '"Nunito Sans", "Montserrat", "Trebuchet MS", sans-serif'
    }}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="text-center" style={{ 
              fontSize: '2.5rem', 
              fontWeight: '700',
              color: '#ffffff',
              marginBottom: '5rem',
              lineHeight: '1.4',
              fontFamily: '"Roboto", "Poppins", sans-serif'
            }}
            data-aos="fade-up"
            >
              {content.title}
            </h2>
          </div>
          
          <div className="row">
            {content.cards.map((card, index) => {
              // Create different animation patterns for jigsaw effect
              const animations = [
                { type: 'flip-left', delay: 100 },
                { type: 'flip-right', delay: 200 },
                { type: 'flip-up', delay: 300 },
                { type: 'flip-down', delay: 100 },
                { type: 'flip-left', delay: 200 },
                { type: 'flip-right', delay: 300 }
              ];
              
              const animation = animations[index] || animations[0];
              
              return (
                <div 
                  key={index} 
                  className="col-lg-4 col-md-6 mb-4"
                  data-aos={animation.type}
                  data-aos-delay={animation.delay}
                  data-aos-duration="800"
                >
                  <div 
                    className="card border-0 shadow-sm h-100"
                    style={{
                      background: card.gradient,
                      color: 'white',
                      borderRadius: '16px',
                      overflow: 'hidden',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0) scale(1)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                    }}
                  >
                    <div className="card-body p-4 text-center">
                      <i 
                        className={`${card.icon} fa-3x mb-3`}
                        style={{ color: 'rgba(255,255,255,0.9)' }}
                      ></i>
                      <h5 
                        className="mb-3"
                        style={{ 
                          color: 'white !important',
                          fontSize: '1.25rem',
                          fontWeight: '600'
                        }}
                      >
                        {card.title}
                      </h5>
                      <p style={{ 
                        color: 'rgba(255,255,255,0.9)',
                        fontSize: '0.95rem',
                        lineHeight: '1.6',
                        fontFamily: '"Tinos", "Times New Roman", serif'
                      }}
                      dangerouslySetInnerHTML={{ __html: card.description }}
                      >
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsGrid;